import Swiper, { Autoplay, Navigation, Scrollbar } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let caseStudiesSwiperWr = document.querySelectorAll('.case-studies-swiper-wr');

caseStudiesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');
    let scrollbarEl = parentEl.querySelector('.case-studies-sec__scrollbar');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Scrollbar],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 14,
      slidesPerView: 1.1,
      threshold: 10,
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        420: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        580: {
          slidesPerView: 2.1,
          spaceBetween: 18,
        },
        768: {
          spaceBetween: 18,
          slidesPerView: 2.5,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
        1280: {
          spaceBetween: 20,
          slidesPerView: 3.333,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
    });
    swiperObserver(swiper);
  }
});